import Button from '@space-core/components/button'
import useTranslation from '@space-core/hooks/useTranslation'
import { loginEventDispatch } from '@space-events/login'

type ButtonStudentProps = {
  isAPhysicalProduct: boolean
  freeSignUp: boolean
  isAuthenticated: boolean
  isPreview?: boolean
}

const handleRedirectToSignIn = (event: React.MouseEvent<HTMLButtonElement>) => {
  event.stopPropagation()
  loginEventDispatch({ signInRedirect: true })
}

const ButtonStudent = ({
  isAPhysicalProduct,
  freeSignUp,
  isAuthenticated,
  isPreview
}: ButtonStudentProps) => {
  const { t } = useTranslation()
  if (!isAPhysicalProduct && !freeSignUp && !isAuthenticated) {
    return (
      <Button
        key='home.card_cta.is_student'
        variation='primary'
        className='_w-full _mt-5'
        {...(!isPreview && { onClick: (event) => handleRedirectToSignIn(event) })}>
        {t('home.card_cta.is_student')}
      </Button>
    )
  }

  return null
}

export default ButtonStudent
